<div fxLayout="row wrap" fxLayoutAlign="center" class="p-20">
  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando">
    <ng-container *ngIf="cargaTemplate">
      <div class="statusDiv" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="roundEdg done mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'TEMPLATE.PANT_TEMPLATE.TEMP_CARG_TIT_CAR'| translate}}</h2>
          <mat-icon class="ml-20 s-40">check_circle</mat-icon>
        </div>
      </div>

      <div class="mt-40" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <!-- <h2 class="mt-0">{{'TEMPLATE.PANT_TEMPLATE.TEMP_CARG_TIT'| translate}}</h2>
          <mat-divider></mat-divider> -->
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'TEMPLATE.PANT_TEMPLATE.TOT_PREG'| translate}}: <span class="font-size-54 font-weight-300 line-height-1 mt-8"> {{totalPreguntasCargadas}}</span></div>
            <!-- <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntas}}</div> -->
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'TEMPLATE.PANT_TEMPLATE.TOT_PREG_MODI'| translate}}: <span class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntaModificadasCargadas}} </span></div>
            <!-- <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntaModificadas}}</div> -->
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'TEMPLATE.PANT_TEMPLATE.TOT_PREG_NUE'| translate}}: <span class="font-size-54 font-weight-300 line-height-1 mt-8"> {{totalPreguntaNuevasCargadas}}</span> </div>
            <!-- <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntaNueva}}</div> -->
          </div>
          <mat-divider></mat-divider>

        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!cargaTemplate">

      <div class="statusDiv">
        <!-- <div  class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.NOBD' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div> -->
        <!-- <div *ngIf="files.length > 0 && errores.length > 0" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.ERROR' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
        <div *ngIf="files.length > 0 && errores.length == 0" class="roundEdg primary mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
          <h2>{{'CERTIFICAR.COLABORADORES.STATUSBAR.PROCES' | translate}}</h2>
          <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div> -->
      </div>

      <div *ngIf="!cargandoTemplatePreguntas && files.length == 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <!-- <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_NOBD.TITULO' | translate}}</h2>
          <mat-divider></mat-divider> -->
          <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_1</mat-icon>
            <div class="h3 secondary-text"><b>{{'TEMPLATE.PANT_TEMPLATE.INST_1'| translate}}</b></div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="mb-20">

            <!-- <button mat-raised-button class="mb-20 " color="accent" (click)="reemplazarPreguntasPorCatalogo()">
              categoriza preguntas del catalogo
              <mat-icon class="ml-20">cloud_download</mat-icon>
            </button> -->
            <ng-container *ngIf="!preguntasCatalogoCargadas">
              <h3>{{'TEMPLATE.PANT_TEMPLATE.CARGANDO_PREGUNTAS'| translate}}</h3>
              <mat-spinner diameter="30" class="ml-20"></mat-spinner>
            </ng-container>

            <button mat-raised-button class="mb-20 primary" (click)="descargaExcel()" [disabled]="!jsonCuestionario || !preguntasCatalogoMaestro || pasoCompleto" *ngIf="preguntasCatalogoCargadas">
              {{'TEMPLATE.PANT_TEMPLATE.BTN_DESC_PLAN'| translate}}
              <mat-icon class="ml-20">cloud_download</mat-icon>
            </button>

          </div>
          <mat-divider></mat-divider>
          <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_2</mat-icon>
            <div class="h3 secondary-text"><b>{{'TEMPLATE.PANT_TEMPLATE.INST_2'| translate}}</b></div>
          </div>
          <mat-divider></mat-divider>
           <div fxLayout="row" fxLayoutAlign="start center" class="mt-20 mb-20">
            <mat-icon class="s-30 mr-20">filter_3</mat-icon>
            <div class="h3 secondary-text"><b>{{'TEMPLATE.PANT_TEMPLATE.INST_3'| translate}}</b></div>
          </div>
          <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (onFileDropped)="uploadFile($event)" *ngIf="totRows == 0 && !cargandoBD && !pasoCompleto"
            [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
            <input hidden type="file" #fileInput (change)="cargaExcelTemplate($event)" accept="application/vnd.ms-.sheet.macroEnabled.12, application/vnd.ms-.sheet.macroenabled.12" [disabled]="pasoCompleto">
            <h1>{{'TEMPLATE.PANT_TEMPLATE.BUSC_PLAN_TEX'| translate}}</h1>
          </div>

        </div>

      </div>

      <!-- formulario cuando no hay errores -->
      <div *ngIf="!cargandoTemplatePreguntas && files.length > 0" class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">

        <div class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'TEMPLATE.PANT_TEMPLATE.TEMP_CARG_TIT'| translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'TEMPLATE.PANT_TEMPLATE.TOT_PREG'| translate}}: <span class="font-size-54 font-weight-300 line-height-1 mt-8"> {{totalPreguntas}}</span></div>
            <!-- <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntas}}</div> -->
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'TEMPLATE.PANT_TEMPLATE.TOT_PREG_MODI'| translate}}: <span class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntaModificadas}} </span></div>
            <!-- <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntaModificadas}}</div> -->
          </div>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'TEMPLATE.PANT_TEMPLATE.TOT_PREG_NUE'| translate}}: <span class="font-size-54 font-weight-300 line-height-1 mt-8"> {{totalPreguntaNueva}}</span> </div>
            <!-- <div class="font-size-54 font-weight-300 line-height-1 mt-8">{{totalPreguntaNueva}}</div> -->
          </div>
          <mat-divider></mat-divider>

          <div class="mt-20 h2 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_NOERR.GUARDAR' | translate}}</div>
          <div class="mt-20" fxLayout="row" fxLayoutAlign="space-between stretch">
            <button mat-raised-button class="warn" fxFlex="45" (click)="deleteAttachment(i,true)">
              {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.NO' | translate}}
            </button>
            <button mat-raised-button class="primary" fxFlex="45" (click)="guardaPlantillaExcel()">
              {{'CERTIFICAR.COLABORADORES.CARD_NOERR.BOTONES.SI' | translate}}
            </button>
          </div>
        </div>

      </div>

      <!-- pantalla "cargando" y "guardando" -->
      <div class="mt-20" fxFlex="100" fxLayout="row" fxLayoutAlign="space-around stretch">
        <!--- cargando excel en front --->
        <div *ngIf="cargandoTemplatePreguntas && varibleModal==1" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.CARGA.INFO' | translate}}</div>
            <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
          </div>
        </div>
        <!--- guardando registros en back --->
        <div *ngIf="guardandoTemplatePreguntas && varibleModal==2" class="mat-elevation-z3 p-20" fxFlex="60" fxLayout="column" fxLayoutAlign="space-between stretch"
          [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <h2 class="mt-0">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.TITULO' | translate}}</h2>
          <mat-divider></mat-divider>
          <div class="mt-20 mb-20">
            <div class="h4 secondary-text">{{'CERTIFICAR.COLABORADORES.CARD_LOAD.GUARDA.INFO' | translate}}</div>
            <mat-progress-bar mode="indeterminate" class="mt-20"></mat-progress-bar>
          </div>
        </div>
      </div>

    </ng-container>
  </ng-container>


  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt">
    <button *ngIf="!pasoCompleto && !cargando" (click)="completarPaso()" mat-fab aria-label="boton completar paso"
      matTooltip="{{'CERTIFICAR.ADICIONALES.STATUS.PEND' | translate}}" matTooltipPosition="left" class="undone mr-20"
    >
      <mat-icon>done</mat-icon>
    </button>
    <button *ngIf="pasoCompleto && !cargando" (click)="completarPaso()" mat-raised-button class="done mr-20">
      {{'CERTIFICAR.ADICIONALES.STATUS.DONE' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>

    <!-- <button *ngIf="pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearColaboradores()" mat-fab aria-label=""
      matTooltip="{{'CERTIFICAR.COLABORADORES.STATUS.LOCK' | translate}}" matTooltipPosition="left" class="undone mr-20"
      >
      <mat-icon>lock_open</mat-icon>
    </button>

    <button *ngIf="!pasoCompleto && !cargando && (validationUser || desbloqueoEstatus) && !validationSurvey" (click)="desbloquearColaboradores()" mat-raised-button class="reopen mr-20">
      {{'CERTIFICAR.COLABORADORES.STATUS.UNLOCK' | translate}}
    </button> -->
  </div>

</div>
